export var CONST = {
  APIURL: {
    DOMAIN: 'http://www.hoyware.com',
    PREDOMAIN: 'http://www.hoyware.com',
    HOST: '',
    ROUTER: {
      RESOURCES: '/api/v1'
    },
    WS: {
      msg: process.env.VUE_APP_WS_API + '/api/v1/ws/msg',
      alarm: process.env.VUE_APP_WS_API + '/api/v1/ws/alarm',
      notice: process.env.VUE_APP_WS_API + '/api/v1/ws/notice/:uniqueId',
      rdcsm50: process.env.VUE_APP_WS_API + '/api/v1/ws/50rdcsm',
      responseData: process.env.VUE_APP_WS_API + '/api/v1/ws/data'
    }
  }
};